import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatError, MatFormField, MatHint, MatLabel, MatPrefix, MatSuffix } from '@angular/material/select';
import { TextFieldComponent } from '@src/suite/common/controls/text-field/text-field';
import { CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';

@Component({
    selector: 'st-text-field-currency',
    imports: [CurrencyMaskModule, FormsModule, MatError, MatFormField, MatHint, MatInput, MatLabel, MatPrefix, MatSuffix],
    templateUrl: './text-field-currency.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-text-field-currency',
    },
})
export class TextFieldCurrencyComponent extends TextFieldComponent {
    public currencyMaskConfig: CurrencyMaskConfig = {
        align: 'left',
        allowNegative: false,
        decimal: '.',
        precision: 2,
        prefix: this.languageSettings.PSTWebCostCurrencyLabel,
        suffix: '',
        thousands: '',
    };
}
